@if (showMatrix && !matrixLoader) {
<div class="container-fluid inbuilt-table-block p-1">
  <!-- Header: report name, count, timestamp, expand/collapse -->
  <div class="row">
    <div class="col-12 col-xxl-6 col-xl-6 col-lg-6 col-md-12 col-sm-12 d-flex align-items-center">
      <p class="m-0 mt-2 report-fetch-details">
        {{ config?.reportNameFromQueryParams | titlecase }} : {{ parentRows.length || 0 }} rows as of
        {{ currentDate | date: 'MMMdd,yyyy':'GMT' }} {{ currentTime }}
      </p>
    </div>
    <div class="col-12 col-xxl-6 col-xl-6 col-lg-6 col-md-12 col-sm-12 text-right">
      <div class="m-2">
        <button
          class="ms-2 uitk-c-button uitk-c-button--default mat-mdc-raised-button techops-global-button uitk-u-margin-right--base"
          (click)="toggleExpandCollapseAll()"
          [disabled]="parentRows.length === 0"
        >
          {{ allExpanded ? 'Collapse All' : 'Expand All' }}
        </button>
        <span
          (click)="!(parentRows.length === 0) && downloadToExcel()"
          title="Click to Download"
          [class.cursor-not-allowed]="parentRows.length === 0"
          [class.opacity-50]="parentRows.length === 0"
          [ngClass]="{ 'pointer-events-none': parentRows.length === 0 }"
          class="uitk-icon uitk-icon-download md-icon excel_Download cursor-pointer excelandinfo-Icon-font"
        ></span>
        <!-- <div class="export-loader ms-2" *ngIf="isExporting" style="display: inline-block;">
          <mat-spinner class="spinner" diameter="24"></mat-spinner>
        </div> -->
      </div>
    </div>
  </div>
  <!-- Empty state -->
  @if (!loading && parentRows.length === 0) {
  <div class="matrix-empty">
    No parent child table data available.
  </div>
  }
  <!-- Parent grid with inline child detail rows -->
  @if (!loading && parentRows.length > 0) {
  <div class="row mt-2">
    <div class="col-12 pct-groups-container">
      <ag-grid-angular
        class="ag-theme-alpine pct-parent-grid"
        [rowData]="parentGridData"
        [columnDefs]="parentColDefs"
        [defaultColDef]="defaultColDef"
        [domLayout]="'normal'"
        [headerHeight]="40"
        [getRowHeight]="getParentRowHeight"
        [getRowClass]="getParentRowClass"
        [suppressHorizontalScroll]="true"
        [suppressMovableColumns]="true"
        [rowBuffer]="10"
        (gridReady)="onGridReady($event)"
        (cellClicked)="onParentCellClicked($event)"
      >
      </ag-grid-angular>
    </div>
  </div>
  }
  <!-- Loading overlay -->
  @if (loading) {
  <div class="matrix-loading-overlay">
    <mat-spinner diameter="50" strokeWidth="4"></mat-spinner>
  </div>
  }
</div>
} @if (showMatrix && matrixLoader) {
<div class="d-flex align-items-center justify-content-center">
  <app-loader></app-loader>
</div>
}
